const Sidebar = () => {
	return (
		<aside className='w-full lg:w-1/3 bg-blue-50 p-4 rounded-xl text-gray-700 border-blue-200 border-2'>
			{/* البحث */}
			<div className='mb-6'>
				<h3 className='text-blue-600 font-bold mb-2'>البحث</h3>
				<input
					type='text'
					placeholder='...بحث'
					className='w-full p-2 rounded-md border border-gray-600 bg-transparent text-gray-200 focus:outline-none focus:border-blue-600'
				/>
			</div>

			{/* المقالات */}
			<div className='mb-6'>
				<h3 className='text-blue-600 font-bold mb-2'>المقالات</h3>
				<ul className='space-y-2'>
					<li className='hover:text-blue-600 cursor-pointer'>
						الذكاء الاصطناعي
					</li>
					<li className='hover:text-blue-600 cursor-pointer'>المسابقات</li>
					<li className='hover:text-blue-600 cursor-pointer'>علوم البيانات</li>
				</ul>
			</div>

			{/* أحدث المقالات */}
			<div>
				<h3 className='text-blue-600 font-bold mb-2'>أحدث المقالات</h3>
				<div className='flex items-center gap-3 mb-3 cursor-pointer hover:text-blue-600'>
					<img
						src='/images/about.png'
						alt='Laptop'
						width={50}
						height={50}
						className='rounded-md'
					/>
					<span>Laptop Pricing</span>
				</div>
				<div className='flex items-center gap-3 cursor-pointer hover:text-blue-600'>
					<img
						src='/images/about.png'
						alt='Energy'
						width={50}
						height={50}
						className='rounded-md'
					/>
					<span>Energy Consumption</span>
				</div>
			</div>
		</aside>
	);
};

export default Sidebar;
